export interface Address {
  address1: string
  address2?: string
  city: string
  country: string
  province: string
  postal: string
}

// Address is shared by credit-card and virtual-card API responses. Copy its
// wire fields at class-model boundaries so neither model aliases response data
// or carries unrelated runtime fields into the legacy view layer.
export const toAddress = (data: Address): Address => ({
  address1: data.address1,
  address2: data.address2,
  city: data.city,
  country: data.country,
  province: data.province,
  postal: data.postal,
})
